import React from "react";
import "./DeprecatedOnboarding.css";

const DeprecatedOnboarding = () => (
  <main className="deprecated-onboarding">
    <h1>This page is no longer available. Kindly use the main platform for any new onboardings</h1>
  </main>
);

export default DeprecatedOnboarding;
